import { render, staticRenderFns } from "./BasePositionStatus.vue?vue&type=template&id=46f8d678"
import script from "./BasePositionStatus.vue?vue&type=script&lang=js"
export * from "./BasePositionStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports